import { Helmet } from 'react-helmet';
import { isPrerender } from '@medifind/utils';
export const BreadcrumbJsonLd = ({ itemListElements = [] }) => {
  // Name is required
  if (itemListElements.some((d) => !d.name)) return null;
  return (
    <Helmet defer={!isPrerender}>
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'http://schema.org/',
          '@type': 'BreadcrumbList',
          itemListElement: itemListElements.map(({ position, name, href }) => {
            return {
              '@type': 'ListItem',
              position: position,
              name: name,
              ...(href ? { item: process.env.NX_LOCAL_HOST + href } : {}),
            };
          }),
        })}
      </script>
    </Helmet>
  );
};
